export default __webpack_public_path__ + "static/media/team3.63e565fb.jpg";